import s from './teacher-home-analytics.module.scss'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { IconChevronRight, IconCoins, IconDiscount, IconMusic, IconPercentage, IconStarFilled, IconUsers } from '@tabler/icons-react';
import { useMyStudents } from '@features/teacher/add-appointment-by-teacher/api/useMyStudents';
import { useTeacherStudentsListModal } from '@widgets/teacher/ui/students-list-modal';

export const TeacherHomeAnalytics = ({ profile, analytics, className }) => {
	const { data: students } = useMyStudents();
	const { open: openStudentsModal } = useTeacherStudentsListModal();

	const priceValue = profile?.grade?.price
		? `${Number(profile.grade.price).toLocaleString('ru-RU')} ₽`
		: 'Договорная';

	const durationValue = profile?.grade?.duration
		? `${profile.grade.duration} мин`
		: '50 мин';

	const earnedValue = analytics?.earned_total
		? `${Number(analytics.earned_total).toLocaleString('ru-RU')} ₽`
		: '0,00 ₽';

	return (
		<div className={classNames(s.analytics, className)}>
			<div className={s.columns}>
				<div className={s.column}>
					<div className={classNames(s.card, s.gray)}>
						<div className={s.header}>
							<IconDiscount size={20} className={s.icon} />
							<div className={s.value}>{priceValue}</div>
						</div>
						<div className={s.label}>{durationValue}</div>
					</div>
					<NavLink to="/referrals" className={classNames(s.card, s.gray, s.clickable)}>
						<div className={s.header}>
							<IconPercentage size={20} className={s.icon} />
							<div className={s.value}>
								{profile?.referral_level?.name ? `${profile.referral_level.name}` : '—'}
							</div>
						</div>
						<div className={s.label}>
							Комиссия сервиса {profile?.referral_level?.commission_percent ?? 20}%
						</div>
						<IconChevronRight size={20} className={s.chevron} />
					</NavLink>
				</div>

				<div className={s.column}>
					<div className={s.card}>
						<div className={s.header}>
							<IconMusic size={20} className={s.icon} />
							<div className={s.value}>{analytics?.appointments_count || 0}</div>
						</div>
						<div className={s.label}>Проведено уроков</div>
					</div>
					<div className={s.card}>
						<div className={s.header}>
							<IconStarFilled size={20} className={s.icon} />
							<div className={s.value}>{profile?.rating || 0}</div>
						</div>
						<div className={s.label}>Средняя оценка</div>
					</div>
				</div>

				<div className={s.column}>
					<NavLink to="/payment-history" className={classNames(s.card, s.clickable)}>
						<div className={s.header}>
							<IconCoins size={20} className={s.icon} />
							<div className={s.value}>{earnedValue}</div>
						</div>
						<div className={s.label}>Заработано всего</div>
						<IconChevronRight size={20} className={s.chevron} />
					</NavLink>
					<div
						className={classNames(s.card, s.clickable)}
						onClick={() => openStudentsModal()}
						role="button"
						tabIndex={0}
						onKeyDown={(e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								e.preventDefault();
								openStudentsModal();
							}
						}}
					>
						<div className={s.header}>
							<IconUsers size={20} className={s.icon} />
							<div className={s.value}>{students?.length || 0}</div>
						</div>
						<div className={s.label}>Ученика</div>
						<IconChevronRight size={20} className={s.chevron} />
					</div>
				</div>
			</div>
		</div>
	);
};
